@if (authService.account) {
  <div class="content">
    <div class="sub-title">Hei, {{ authService.fullName }}</div>
    <p>
      Beklager - vi kan dessverre ikke se at du har tilgang akkurat nå.<br />Dette kan være et midlertig teknisk
      problem, vennligst prøv igjen senere.
    </p>
    <p>
      Har du nettopp har blitt medlem i Fagforbundet kan du prøve på nytt i morgen da det kan ta noe tid før din tilgang
      til Min Side er aktiv.
    </p>
    <p class="link">
      Dersom du etter gjentatte forsøk ikke kommer inn ber vi deg,
      <a href="https://kontakt.fagforbundet.no" target="_blank">ta kontakt med oss</a> og oppgi gjerne ditt
      medlemsnummer i Fagforbundet.
    </p>

    <hr />

    @if (message) {
      <div class="title-text">Feilkoden som blir returnert</div>
      @if (message) {
        <p>Melding: {{ message }}</p>
      }
    }
    <button type="button" class="button primary" (click)="logout()">Logg ut</button>
  </div>
} @else {
  <div class="content">
    <p>
      Beklager - vi kan dessverre ikke se at du har tilgang akkurat nå.<br />Dette kan være et midlertig teknisk
      problem, vennligst prøv igjen senere.
    </p>
    <p>
      Har du nettopp har blitt medlem i Fagforbundet kan du prøve på nytt i morgen da det kan ta noe tid før din tilgang
      til Min Side er aktiv.
    </p>
    <p class="link">
      Dersom du etter gjentatte forsøk ikke kommer inn ber vi deg,
      <a href="https://kontakt.fagforbundet.no" target="_blank">ta kontakt med oss</a> og oppgi gjerne ditt
      medlemsnummer i Fagforbundet.
    </p>

    <div class="title-text">Feilkoden som blir returnert</div>
    <p>Du har ikke tilgang.</p>
  </div>
}
